export enum Collections {
  CONFIGURATIONS = 'configurations',
  PRICING = 'pricing'
}
